import { render, staticRenderFns } from "./AsideNav.vue?vue&type=template&id=0d9fe8c2"
import script from "./AsideNav.vue?vue&type=script&lang=js"
export * from "./AsideNav.vue?vue&type=script&lang=js"
import style0 from "./AsideNav.vue?vue&type=style&index=0&id=0d9fe8c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports